(() => {
  function lockScroll() {
    document.documentElement.classList.add('is-centered-modal-open');
    document.body.classList.add('is-centered-modal-open');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('is-centered-modal-open');
    document.body.classList.remove('is-centered-modal-open');
  }

  function getModal() {
    return document.querySelector('s-content-modal-centered');
  }

  function openCenteredModal(titleOrOpts, contentMaybe) {
    const modal = getModal();
    if (!modal) {
      console.warn('[centered-modal] <s-content-modal-centered> not found in DOM');
      return;
    }

    bindModalOnce(modal);

    const titleEl = modal.querySelector('.js-centered-modal__title');
    const bodyEl = modal.querySelector('.js-centered-modal__body');
    const panel = modal.querySelector('.s-content-modal-centered__panel');

    let title = '';
    let content = '';
    let maxWidth = null;

    if (typeof titleOrOpts === 'object' && titleOrOpts) {
      title = titleOrOpts.title || '';
      content = titleOrOpts.content || '';
      maxWidth = titleOrOpts.maxWidth || null;
    } else {
      title = titleOrOpts || '';
      content = contentMaybe || '';
    }

    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.innerHTML = content;

    if (panel && maxWidth) {
      panel.style.width = `min(${Number(maxWidth)}px, calc(100vw - 48px))`;
    } else if (panel) {
      panel.style.width = '';
    }

    modal.style.display = 'block';
    modal.classList.add('is-open');
    lockScroll();

    const closeBtn = modal.querySelector('.js-centered-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeCenteredModal() {
    const modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.style.display = 'none';
    unlockScroll();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeCenteredModal();
  }

  function bindModalOnce(modal) {
    // Prevent double-binding if Shopify re-renders sections
    if (modal.dataset.bound === '1') return;
    modal.dataset.bound = '1';

    const overlay = modal.querySelector('.js-centered-modal__overlay');
    const closeBtn = modal.querySelector('.js-centered-modal__close');
    const panel = modal.querySelector('.s-content-modal-centered__panel');

    if (overlay) overlay.addEventListener('click', closeCenteredModal);

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeCenteredModal();
      });
    }

    // prevent overlay-click close when clicking inside the panel
    if (panel) panel.addEventListener('click', (e) => e.stopPropagation());

    document.addEventListener('keydown', onKeydown);
  }

  function tryBindIfExists() {
    const modal = getModal();
    if (modal) bindModalOnce(modal);
  }

  // ✅ Expose API immediately (even before modal exists)
  window.PURRZ = window.PURRZ || {};
  window.PURRZ.openCenteredModal = openCenteredModal;
  window.PURRZ.closeCenteredModal = closeCenteredModal;

  // Bind when DOM is ready
  document.addEventListener('DOMContentLoaded', tryBindIfExists);

  // Bind when Shopify (or your ajax re-render) reloads sections
  document.addEventListener('shopify:section:load', tryBindIfExists);

  // Fallback: if modal gets injected without events, observe briefly
  const obs = new MutationObserver(() => {
    const modal = getModal();
    if (modal) {
      bindModalOnce(modal);
      obs.disconnect();
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
